import React, { forwardRef } from 'react';

import { cn } from 'common/style/utils';

const VStack = forwardRef<HTMLDivElement, React.ComponentProps<'div'>>(
  ({ children, className, ...props }, ref) => {
    return (
      <div ref={ref} className={cn('flex flex-col', className)} {...props}>
        {children}
      </div>
    );
  },
);

export default VStack;
